// tslint:disable
import {style} from 'typestyle'
import * as csstips from 'csstips'

export const title = style({
    height: 48,
    fontSize: 20,
    color: '#333333',
    letterSpacing: 0,
    paddingLeft: 15,
    paddingTop: 10,
    marginBottom: 11,
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.center,
    fontWeight: 600,
    $nest: {
        '@media (min-width: 480px)': {
            marginLeft: 2
        }
    }
})

export const punchCouponWrap = style({
    width: '100%',
    height: '100%',
    padding: '0 15px',
    marginBottom: 6
})

export const couponPriceActive = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    position: 'relative',
    backgroundSize: '100% 110%',
    backgroundRepeat: 'no-repeat',
    height: '100%'
})

export const noUseCoupon = style({
    width: '92vw',
    maxWidth: 441,
    position: 'relative',
    $nest: {
        '& img': {
            width: '100%'
        }
    }
})

export const priceBox = style({
    "width": '28%',
    "height": '100px',
    "position": 'absolute',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    "top": '45%',
    "transform": 'translate(0, -50%)',
    '-webkit-transform': 'translate(0, -50%)'
})

export const couponPrice = style({
    fontSize: 40,
    color: '#FFFFFF',
    letterSpacing: 0,
    lineHeight: '40px',
    fontWeight: 600,
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.end,
    $nest: {
        '& span': {
            fontSize: 20,
            fontWeight: 600,
            color: '#FFFFFF',
            lineHeight: '20px'
        }
    }
})

export const decimalPrice = style({
    fontSize: 30,
    marginBottom: 4,
    $nest: {
        '@media (max-width: 320px)': {
            fontSize: 25
        }
    }
})

export const couponTextBox = style({
    "width": '63.7vw',
    "maxWidth": 305.92,
    "position": 'absolute',
    "right": 0,
    "top": '45%',
    "transform": 'translate(0, -50%)',
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.center,
    '-webkit-transform': 'translate(0, -50%)'
})

export const couponText = style({
    marginLeft: 15,
    $nest: {
        '@media (max-width: 320px)': {
            marginLeft: 10
        }
    }
})

export const usedCouponTitle = style({
    fontSize: 18,
    color: '#cccccc',
    letterSpacing: 0,
    lineHeight: '18px',
    fontWeight: 400,
    marginBottom: 15
})

export const noUseCouponTitle = style({
    fontSize: 18,
    color: '#333333',
    letterSpacing: 0,
    lineHeight: '18px',
    fontWeight: 400,
    marginBottom: 15
})

export const usedValidTime = style({
    fontSize: 12,
    color: '#cccccc',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '14px',
    fontWeight: 400
})

export const noUsevalidTime = style({
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: '14px',
    fontWeight: 400
})

export const clickButtonBox = style({
    "width": '12vw',
    "maxWidth": 57,
    "position": 'absolute',
    "top": '45%',
    "right": 0,
    "transform": 'translate(0, -50%)',
    "height": '100%',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    '-webkit-transform': 'translate(0, -50%)'
})

export const usedClickButton = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    fontSize: 14,
    color: '#CCCCCC',
    letterSpacing: '2px',
    lineHeight: '18px',
    fontWeight: 600,
    width: 4
})

export const noUseClickButton = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    fontSize: 14,
    color: '#FF5A31',
    letterSpacing: '2px',
    lineHeight: '18px',
    height: '100%',
    fontWeight: 600,
    width: 4
})



// WEBPACK FOOTER //
// ./src/views/Punch/MyPunchCoupon/components/PunchCouponList.style.ts